<template>
  <mf-card-container :title="title" class="mb-3">
    <div class="email-preview-container">
      <iframe v-if="htmlContent" :srcdoc="htmlContent" class="email-iframe" frameborder="0" sandbox="allow-same-origin"></iframe>
      <div v-else class="email-content-placeholder">
        <span>Não é possível exibir o conteúdo do e-mail.</span>
      </div>
    </div>
  </mf-card-container>
</template>

<script>
export default {
  name: 'EmailPreview',
  props: {
    title: {
      type: String,
      default: 'Preview do E-mail',
    },
    htmlContent: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.email-preview-container {
  height: 578px;
  overflow: hidden;
}

.email-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.email-content-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  font-style: italic;
}
</style>
